<script>
    // Licensed under Gnu Public Licence version 2
    // Copyright (c) 2024 (original work) Open Assessment Technologies SA ;
    import { __ } from '@oat-sa-private/ui-core';

    export let hiddenText = __('page');
    export let disabled = false;
    export let ariaCurrent = null;
    export let dataPage = null;
</script>

<style>
    .page {
        @add-mixin bold;
        background: none;
        border: none;
        height: 100%;
        width: 100%;
        border-radius: var(--radius-circular);
        font-size: var(--fontsize-body);
        color: var(--color-text-default);
        position: relative;
        cursor: pointer;
        white-space: nowrap;

        @add-mixin outline-focus 0;
        &:focus-visible::after {
            border-radius: var(--radius-circular);
        }

        &[aria-current='page'] {
            border: var(--border-medium) solid var(--color-border-default);

            &::before {
                content: '';
                position: absolute;
                display: block;
                height: 6.5rem;
                width: 6.5rem;
                left: -0.75rem;
                top: -0.75rem;
                border-radius: var(--radius-circular);
            }

            @add-mixin outline-focus;
            &:focus-visible::after {
                border-radius: var(--radius-circular);
            }
        }

        &:hover:not(:disabled) {
            background-color: var(--color-gs-light-hover-bg);
        }

        &:disabled {
            cursor: not-allowed;
            color: var(--color-text-disabled);
        }
    }
</style>

<!-- this classname syntax is important for focus-visible -->
<button class="page" {disabled} aria-current={ariaCurrent} data-page={dataPage} on:click>
    <span class="visually-hidden">{hiddenText}</span>
    <slot />
</button>
